import {
  faBadgeDollar,
  faBuilding,
  faChartNetwork,
  faForkKnife,
  faPills,
  faPlane,
  faRingDiamond,
  faUmbrellaBeach,
  faUser,
} from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { cloneElement } from "react";

const segmentsMapIcon: Record<string, JSX.Element> = {
  wedding: <FontAwesomeIcon icon={faRingDiamond} />,
  corporate: <FontAwesomeIcon icon={faBuilding} />,
  holiday: <FontAwesomeIcon icon={faUmbrellaBeach} />,
  pharmaceutical: <FontAwesomeIcon icon={faPills} />,
  airlines: <FontAwesomeIcon icon={faPlane} />,
  leisure: <FontAwesomeIcon icon={faUmbrellaBeach} />,
  transient: <FontAwesomeIcon icon={faUser} />,
  incentives: <FontAwesomeIcon icon={faBadgeDollar} />,
  association: <FontAwesomeIcon icon={faChartNetwork} />,
  "social catering": <FontAwesomeIcon icon={faForkKnife} />,
};

interface SegmentsIconProps {
  title: string;
  color: string;
  fontSize: string;
}

export default function SegmentsIcons(props: SegmentsIconProps) {
  const { title, ...rest } = props;
  const name = title.toLowerCase();
  const segmentIcon = segmentsMapIcon[name] || null;

  return segmentIcon ? cloneElement(segmentIcon, { ...rest }) : null;
}
